import * as d3 from 'd3';

export function drawHinge(svg, x, y, width, height, frameWidth = 10, hingeType = 0, lineColor = 'red') {
    if (hingeType === 0) return;

    const hingeValue = hingeType === "Left" ? 2 : hingeType === "Right" ? 1 : null;
  
  
    const inset = 0; //frameWidth;
    const x1 = x + inset;
    const x2 = x + width - inset;
    const y1 = y + inset;
    const y2 = y + height - inset;
  
    if (hingeValue === 1) {
      // Left hinge: '>' shape
      // Line from top-left to center-right
      svg.append('line')
        .attr('x1', x1)
        .attr('y1', y1)
        .attr('x2', x2)
        .attr('y2', y + height / 2)
        .attr('stroke', lineColor)
        .attr('stroke-width', 1)
        .attr('stroke-dasharray', '6,4');
  
      // Line from bottom-left to center-right
      svg.append('line')
        .attr('x1', x1)
        .attr('y1', y2)
        .attr('x2', x2)
        .attr('y2', y + height / 2)
        .attr('stroke', lineColor)
        .attr('stroke-width', 1)
        .attr('stroke-dasharray', '6,4');
  
    } else if (hingeValue === 2) {
      // Right hinge: '<' shape
      // Line from top-right to center-left
      svg.append('line')
        .attr('x1', x2)
        .attr('y1', y1)
        .attr('x2', x1)
        .attr('y2', y + height / 2)
        .attr('stroke', lineColor)
        .attr('stroke-width', 1)
        .attr('stroke-dasharray', '6,4');
  
      // Line from bottom-right to center-left
      svg.append('line')
        .attr('x1', x2)
        .attr('y1', y2)
        .attr('x2', x1)
        .attr('y2', y + height / 2)
        .attr('stroke', lineColor)
        .attr('stroke-width', 1)
        .attr('stroke-dasharray', '6,4');
    }
  }